import axios from 'axios';
import tools from './tools';


// List all course per university
export async function userInfo(queryParams, cancelTokenParam ) {  
  queryParams = queryParams || {}; 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();
  
  const fields = queryParams.fields || "id,profile_picture_thumbnail";
  const expand = queryParams.expand;
  const ordering = queryParams.ordering || "name";
  const limit = queryParams.limit || 'no_paginate';
  const offset = queryParams.offset || 0; 

  var url = `${tools.getBaseHost()}/account/me/`;  

  const request = axios.get(url, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    params: {
      fields,
      expand,
      ordering,
      limit,
      offset
    },
    cancelToken: cancelToken.token 
  });
  return request;
}

export default {
  userInfo,
}